class HttpResponse {
  constructor({ status, data } = {}) {
    this.status = status;
    this.data = data;
  }
}

export default HttpResponse;
